import { render } from "./GetStartedText.vue?vue&type=template&id=85bb6778&scoped=true"
import script from "./GetStartedText.vue?vue&type=script&lang=js"
export * from "./GetStartedText.vue?vue&type=script&lang=js"

import "./GetStartedText.vue?vue&type=style&index=0&id=85bb6778&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85bb6778"]])

export default __exports__